'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.betausers.add', [])
  .controller('BetaUsersAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/betausers/add/index.js